export const GET_ALL_COUNTER_TRANSFER_COEFFICIENT = "GET_ALL_COUNTER_TRANSFER_COEFFICIENT"
export const CREATE_COUNTER_TRANSFER_COEFFICIENT = "CREATE_COUNTER_TRANSFER_COEFFICIENT"
export const UPDATE_COUNTER_TRANSFER_COEFFICIENT = "UPDATE_COUNTER_TRANSFER_COEFFICIENT"
export const DELETE_COUNTER_TRANSFER_COEFFICIENT = "DELETE_COUNTER_TRANSFER_COEFFICIENT"
